import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: '/:channel/notes',
  name: 'Notes',
  component: Layout,
  protected: true,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/notes/route.js